import { useRef } from "react";
import "../../../css/DesignSystem/Upload/FileUpload.css";
import {ReactComponent as UploadIcon} from '../../../assets/icons/upload-icon.svg';

const FileUpload = ({
  label,
  description = "Drag & drop files here or",
  browseText = "Browse",
  status = "default",
  statusMessage,
  fileName,
  onBrowse,
  onDrop,
  onRemove,
  disabled = false,
}) => {
  const inputRef = useRef(null);

  const handleBrowse = () => {
    if (disabled) return;
    if (onBrowse) {
      onBrowse();
      return;
    }
    inputRef.current?.click();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (disabled) return;
    onDrop?.(event);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <div className="ds-upload">
      {label && <div className="ds-upload-label">{label}</div>}
      <div
        className={`ds-upload-dropzone ds-upload-dropzone--${status} ${
          disabled ? "ds-upload-dropzone--disabled" : ""
        }`}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <div className="ds-upload-row">
          <div className="ds-upload-icon" aria-hidden>
            <UploadIcon />
          </div>
          <div className="ds-upload-text">
            <div className="Content">{description}</div>
            <button
              type="button"
              className="ds-upload-browse "
              onClick={handleBrowse}
              disabled={disabled}
            >
              {browseText}
            </button>
          </div>
          {fileName && (
            <button
              type="button"
              className="ds-upload-remove"
              onClick={onRemove}
              aria-label="Remove file"
            >
              ×
            </button>
          )}
        </div>
        {/* {statusMessage && (
          <div className={`ds-upload-status ds-upload-status--${status}`}>
            {statusMessage}
          </div>
        )} */}
        {fileName && <div className="ds-upload-filename">{fileName}</div>}
      </div>
      <input ref={inputRef} type="file" className="ds-upload-input" />
    </div>
  );
};

export default FileUpload;
